import { useNavigate } from "react-router-dom";

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // go back
    } else {
      navigate("/"); // fallback to login
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
        <div className="flex justify-end mb-2">
          <button
            onClick={handleBack}
            className="px-4 py-2 text-sm font-semibold bg-gray-100 hover:bg-gray-200 rounded-xl shadow-sm"
          >
            ← Back
          </button>
        </div>

        <h1 className="text-3xl font-bold text-blue-900 mb-2">
          Privacy Policy — SOTA Steel Order System
        </h1>

        <p className="text-gray-700 mb-4">
          SOTA (Steel Order System) is an order placement platform operated
          under the Friends Steel brand, represented by its group companies
          including:
        </p>

        <div className="bg-blue-50 border border-blue-100 rounded-xl p-5 mb-6">
          <ul className="list-disc pl-6 space-y-1 text-gray-800">
            <li>Aashiana Rolling Mills Ltd.</li>
            <li>Darpan Ispat Pvt. Ltd.</li>
            <li>Friends Concast Limited</li>
            <li>Friends Ispat Limited</li>
            <li>GNG Alloys Private Limited</li>
          </ul>
        </div>

        <p className="text-gray-700 mb-6">
          This platform is intended only for authorized dealers for placing and
          managing structure steel orders.
        </p>

        {/* Section */}
        <Section title="1. Information We Collect">
          <p>When authorized users access and use SOTA, we may process:</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Mobile number (WhatsApp OTP login)</li>
            <li>Dealer / Firm name (from pre-approved database)</li>
            <li>GST, credit limit, outstanding status already in records</li>
            <li>
              Order details — product, size, quantity, delivery, payment terms,
              remarks
            </li>
          </ul>
          <p className="mt-2">
            No file or document uploads are taken through this platform.
          </p>
        </Section>

        <Section title="2. How We Use Information">
          <ul className="list-disc pl-6 space-y-1">
            <li>User authentication via OTP</li>
            <li>Display authorized dealer details</li>
            <li>Process order requests</li>
            <li>Internal sales and dispatch coordination</li>
            <li>Audit and transaction records</li>
            <li>System performance improvement</li>
          </ul>
        </Section>

        <Section title="3. Data Storage">
          <p>
            Order and dealer data is stored in Google Sheets–based systems
            managed via Google Apps Script and controlled by authorized teams.
          </p>
        </Section>

        <Section title="4. Data Sharing">
          <p>
            Data is never sold or rented. Access is limited to authorized
            internal sales, operations, and accounts teams strictly for order
            processing.
          </p>
        </Section>

        <Section title="5. Third-Party Services">
          <ul className="list-disc pl-6 space-y-1">
            <li>Google Apps Script</li>
            <li>Google Sheets</li>
            <li>WhatsApp OTP messaging services</li>
          </ul>
          <p className="mt-2">
            These are used only for system operation and authentication.
          </p>
        </Section>

        <Section title="6. Security">
          <p>
            Reasonable administrative and technical safeguards are applied.
            Access is restricted to authorized personnel only.
          </p>
        </Section>

        <Section title="7. User Eligibility">
          <p>
            This system is intended only for authorized dealers in India and
            approved internal testing users. It is not for public consumer use.
          </p>
        </Section>

        <Section title="8. User Requests and Data Correction">
          <p>
            Authorized users may request corrections or raise privacy concerns
            using the contact details below.
          </p>
        </Section>

        <Section title="9. Contact for Privacy Matters">
          <div className="bg-gray-50 border rounded-xl p-5 mt-3">
            <p className="font-semibold text-gray-900">
              SOTA Support — Friends Steel
            </p>
            <p className="mt-2">
              📧 Email:{" "}
              <a
                href="mailto:DME@friendssteel.com"
                className="text-blue-700 font-medium hover:underline"
              >
                DME@friendssteel.com
              </a>
            </p>
            <p>
              🌐 Website:{" "}
              <a
                href="https://so.friendssteel.com/"
                target="_blank"
                rel="noreferrer"
                className="text-blue-700 font-medium hover:underline"
              >
                https://so.friendssteel.com/
              </a>
            </p>
          </div>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="mb-7">
      <h2 className="text-xl font-semibold text-blue-900 mb-3">{title}</h2>
      <div className="text-gray-700 space-y-2 leading-relaxed">{children}</div>
    </div>
  );
}
